"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utility = void 0;
const Labels_1 = require("./Labels");
class Utility {
    static enumerableErrors(value) {
        // copy non-enumerable properties from error object
        const plainObject = {};
        const errorObject = value;
        if (value.isAxiosError) {
            plainObject.name = value.name;
            plainObject.message = value.message;
            plainObject.statusCode = value.response?.status;
            plainObject.type = value.response?.type;
            plainObject.data = value.response?.data;
            plainObject.stack = value.stack;
        }
        else {
            Object.getOwnPropertyNames(value).forEach((key) => {
                plainObject[key] = errorObject[key];
            });
        }
        return plainObject;
    }
    static getPrincipal(payload) {
        let principalId = payload?.sub;
        // ROPC Flow returns older tokens which do not support sub, revert to oid
        if (principalId === Labels_1.Labels.UnsupportedSub) {
            principalId = payload.oid;
        }
        return principalId;
    }
}
exports.Utility = Utility;
//# sourceMappingURL=Utility.js.map